import common from '@namespace/common/index'
import home from '@namespace/home/index'
// import contact from '@namespace/contact/index'

common()
home()
// contact()
